module.exports = __webpack_public_path__ + "img/thumb_2018-04.0b64553b.jpg";